import Landing from "../../../../translation/CustomPages/DeliverGpt/Landing/es/DeliverGpt.json"; 



export default {
    Landing
};
